export const LOADING = "LOADING";

export const loading = (payload)=>{
  return (dispatch) => {
    dispatch({
      type: LOADING,
      payload
    });
  };
}